import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyBt1vHXPQMP6gOMnjt-zvOqFjHiCEXoJVk',
  authDomain: 'novo-nordisk-know-your-insulin.firebaseapp.com',
  projectId: 'novo-nordisk-know-your-insulin',
  storageBucket: 'novo-nordisk-know-your-insulin.appspot.com',
  messagingSenderId: '826584173922',
  appId: '1:826584173922:web:0c4c9bf9a928b01900303b',
  // measurementId: 'G-MYCN9XLCDX',
}

firebase.initializeApp(firebaseConfig)

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const ChatDb = firebaseDb.ref('chat')
const ChatAuditoriumDb = firebaseDb.ref('chatAuditorium')
const ChatMcDb = firebaseDb.ref('chatMc')
const NoticeDb = firebaseDb.ref('notice')
const TimerDb = firebaseDb.ref('timer')
const AccessDb = firebaseDb.ref('access')
const CheckInDb = firebaseDb.ref('checkin')
const NotificationDb = firebaseDb.ref('pushNotifications')

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  ChatAuditoriumDb,
  ChatMcDb,
  NoticeDb,
  NotificationDb,
  TimerDb,
  CheckInDb,
  AccessDb,
}
